import { WebChatActivity } from 'botframework-webchat-core';
import { Activity, FeedbackEntity } from './types';

export const getLastBotMessage = (messages: Activity[]): Activity | null => {
    let i = messages.length - 1;
    let foundLastMessage = false;
    while (i >= 0) {
        const message = messages[i];
        if (
            message &&
            message.from.role === 'bot' &&
            message.type === 'message'
        ) {
            foundLastMessage = true;
            break;
        }
        i--;
    }
    if (i < 0 || !foundLastMessage) {
        return null;
    }
    return messages[i];
};

export const getLastBotActivity = (
    messages: WebChatActivity[]
): WebChatActivity | undefined => {
    let i = messages.length - 1;
    let foundLastMessage = false;
    while (i >= 0) {
        const message = messages[i];
        if (message && message.from.role === 'bot') {
            foundLastMessage = true;
            break;
        }
        i--;
    }
    if (i < 0 || !foundLastMessage) {
        return;
    }
    return messages[i];
};

export const craftCustomActivityMessage = (
    message?: string,
    name?: string,
    attachments?: any,
    intent = '',
    source = '',
    isFeedbackable = false
): Activity => {
    return {
        id: '',
        from: {
            name: '',
            role: 'bot',
        },
        channelData: {},
        text: message,
        type: 'message',
        name: name || 'custom_message',
        attachments: attachments,
        entities: [
            {
                feedback: isFeedbackable,
                intent: intent,
                source: source,
            } as FeedbackEntity,
        ],
        timestamp: new Date().toISOString(),
    };
};

export const hasMultipleUserMessages = (messages: Activity[]): boolean => {
    // The greeting intents are done through replayUtterance, which mimics a user re-sending the message. Exclude them for cosmetic reasons
    const userMessages = messages.filter(
        (m) =>
            m.from.role === 'user' &&
            m.text &&
            !['/EXTERNAL_greet_step2', '/EXTERNAL_skip_greet'].includes(m.text)
    );
    return userMessages.length >= 2;
};
